import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { MainModal } from "../../../../components/modal/MainModal";
import { PasswordInput } from "../../../../components/Input.js/Input";
import { showToast } from "../../../../utils/showToast";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";
import { ErrorList } from "./ErrorList";
import { usersApi } from "../api";
import { passwordSchemaTest } from "../../../../utils/password-utils";

const schema = object({
  password: string().label("Password").min(6).max(40).test(passwordSchemaTest)
}).required();

export const ResetPassword = ({ isOpen, onClose, selected: { id, name } }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isDirty }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const resetPassword = async (password) => {
    const { organization_id } = getBaseUrlParams();
    try {
      let res = await usersApi.resetPassword({
        organization_id,
        id: id.toString(),
        user: { password }
      });
      onClose();
      showToast(res.data.message);
    } catch (err) {
      for (let key in err.response.data) {
        let error = err.response.data[key];
        setError(key, {
          type: "server",
          message: key + " " + Array.isArray(error) ? error[0] : error
        });
      }
    }
  };

  const primaryButtonDisabled = !isDirty;

  const onSave = async (data) => {
    await resetPassword(data.password);
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={onClose}
        parentSelector=".users"
        headerText={
          <>
            Reset Password - <span className="text-bold">{name}</span>
          </>
        }
        headerCloseHandler={onClose}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={handleSubmit(onSave)}
        secondaryBtnText="Cancel"
        secondaryBtnClass="secondary"
        secondaryBtnHandler={onClose}
        containerClassName="mirror"
        height="auto"
        width={600}
        isAdminPanel={false}
      >
        <PasswordInput customProps={register("password")} autoComplete="off" />
        <p>* The user will be asked to reset their password at next login.</p>
        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
